export class AreaFlooraModel {
  public type_user: any[] = []; //type_user
  public type: string; //office
  public type_portal: any[] = [];
  public profile: string;  //type_wallet
  public notes: string;  //notes
}